import React from 'react';
import ErrorMessage from './ErrorMessage';
import ErrorBoundary from './ErrorBoundary';
import { Link } from 'react-router-dom';

function MinimalPageErrorBoundaryUI(props) {
  return (
    <div className="p-4">
      <ErrorMessage {...props}>
        <Link to="/dashboard">Take me to the dashboard</Link>
      </ErrorMessage>
    </div>
  );
}

function MinimalPageErrorBoundary({ children }) {
  return (
    <ErrorBoundary fallbackUI={MinimalPageErrorBoundaryUI}>
      {children}
    </ErrorBoundary>
  );
}

export default MinimalPageErrorBoundary;
